<div class="apg-panel qq-inclusions" [appScrollIntoView]="true">
  <div class="header">
    <h2>Your Quote</h2>
  </div>

  <app-current-quote [quote]="quote" quoteIndex="1">
  </app-current-quote>

  <div>
    <a href="javascript:void(0)" (click)="changeQuote(quote)">
      Change Quote
    </a>
  </div>

  <div *ngIf="ciTerm > 0" class="ion-margin-top">
    <form #ciForm="ngForm">
      <app-question [question]="includeCIQuestion"></app-question>
    </form>
  </div>

  <div *ngIf="includeCI === false">
    <div class="summary__buttons">
      <ion-button (click)="select(quote)">
        Continue
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </ion-button>
    </div>
  </div>

  <div *ngIf="includeCI">
    <ion-spinner *ngIf="loading"></ion-spinner>
    <div class="qq-inclusions__block" *ngIf="!loading && error" [innerHtml]="error"></div>

    <div *ngIf="!loading && !error" class="offers">

      <h4>
        <ion-icon name="add"></ion-icon>

        Add Life with Multi-Claim Critical Illness Cover 

        <app-help-popup key="QuickQuote.CriticalIllnessHelp">
        </app-help-popup>
      </h4>

      <div [appScrollIntoView]="true" class="quotes">
        <app-quote-option [quote]="quoteCI1" [premium]="quoteCI1.result.premium - quote.result.premium"
                          (select)="select(quoteCI1)">
        </app-quote-option>
        
        <app-quote-option [quote]="quoteCI2" [premium]="quoteCI2.result.premium - quote.result.premium"
                          (select)="select(quoteCI2)">
        </app-quote-option>
      </div>

      <p class="divider"><i>- or -</i></p>

      <app-custom-quote [quote]="quote" [term]="ciTerm" (select)="select($event)">
      </app-custom-quote>
    </div>


    <div class="summary__buttons" *ngIf="!loading && includeCI !== null">
      <a (click)="select(quote)" href="javascript:void(0)">
        Continue without Critical Illness
      </a>
    </div>
  </div>